export default __webpack_public_path__ + "static/media/dark_check_icon.11bf4287.svg";